export default __webpack_public_path__ + "static/media/logo-rabby.477a4097.svg";